<template>
	<div class="public-content theme-management" ref="managementContent">
		<div class="region-title" style="background: #fff">预约服务</div>
		<el-form :inline="true" :model="filterFormModel" class="filter-form-container">
			<el-row :gutter="20">
				<el-col :span="6">
					<el-form-item label="店铺号:">
						<!-- <el-input v-model="formInline.code" placeholder="请输入店铺号"></el-input> -->
						<el-select clearable v-model="filterFormModel.storeId" :filter-method="filterMethod" filterable placeholder="请输入店铺号">
							<el-option v-for="item in storeListByCode" :key="item.id" :label="item.code" :value="item.storeId"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="店铺名称:">
						<el-select clearable v-model="filterFormModel.storeId" :filter-method="filterByName" filterable placeholder="请输入店铺名称">
							<el-option v-for="item in storeListByCode" :key="item.id" :label="item.shopName" :value="item.storeId"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="业务:">
						<el-select clearable v-model="filterFormModel.salesmanId" :filter-method="selectSalemanList" filterable placeholder="请输入业务名称">
							<el-option v-for="item in salemanList" :key="item.id" :label="item.fullName" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="状态:" label-width="54px">
						<el-select v-model="filterFormModel.status" placeholder="请选择" clearable>
							<el-option label="预约成功" value="1"></el-option>
							<el-option label="已取消" value="2"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :span="20">
					<el-form-item label="预约日期:">
						<el-date-picker v-model="filterFormModel.reservationDate" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable format="yyyy-MM-dd"
							value-format="yyyy-MM-dd"></el-date-picker>
					</el-form-item>
				</el-col>
				<el-col :span="3">
					<el-form-item>
						<el-button round @click="handleSearch">查询</el-button>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<div class="data-list">
			<el-table :data="tableData" style="width: 100%;margin-bottom: 20px;" row-key="id" border :row-class-name="rowClassName">
				<el-table-column min-width="100px" prop="storeCode" label="店铺号"> </el-table-column>
				<el-table-column min-width="100px" prop="storeName" label="店铺名称">
				</el-table-column>
				<el-table-column min-width="100px" prop="salesmanName" label="业务">
				</el-table-column>
				<el-table-column min-width="100px" prop="contacts" label="客户姓名">
				</el-table-column>
				<el-table-column min-width="140px" prop="contactNumber" label="联系电话">
				</el-table-column>
				<el-table-column min-width="140px" prop="shootingTime" label="预约日期">
					<template v-slot="scope">
						<span v-if="scope.row.shootingTime">{{ scope.row.shootingTime }}</span>
						<span v-else>暂不确定</span>
					</template>
				</el-table-column>
				<el-table-column min-width="140px" prop="dateCreated" label="提交日期">
				</el-table-column>
				<el-table-column min-width="100px" prop="status" label="状态">
					<template v-slot="scope"> {{ scope.row.status === 2 ? '已取消' : '预约成功' }} </template>
				</el-table-column>
				<el-table-column width="100px" label="操作" fixed="right">
					<template v-slot="scope">
						<span class="color-blue" @click="handleViewDetail(scope.row)">查看详情<br></span>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<!--    分页-->
		<v-pagination class="v-pagination" :queryInfo="queryInfo" @changePage="fetchList"></v-pagination>
		<el-dialog :close-on-click-modal="false" title="预约详情" :visible.sync="detailDialog" width="30%">
			<el-row style="margin-bottom: 16px;">
				<el-col :span="4">
					<span>客户姓名：</span>
				</el-col>
				<el-col :span="20">
					<span>{{ detailData.contacts }}</span>
				</el-col>
			</el-row>
			<el-row style="margin-bottom: 16px;">
				<el-col :span="4">
					<span>联系电话:</span>
				</el-col>
				<el-col :span="20">
					<span>{{ detailData.contactNumber }}</span>
				</el-col>
			</el-row>
			<el-row style="margin-bottom: 16px;">
				<el-col :span="4">
					<span>预约日期：</span>
				</el-col>
				<el-col :span="20">
					<span v-if="detailData.shootingTime">{{ detailData.shootingTime }}</span>
					<span v-else>暂不确定</span>
				</el-col>
			</el-row>
			<el-row style="margin-bottom: 16px;">
				<el-col :span="4">
					<span>备注：</span>
				</el-col>
				<el-col :span="20">
					<span>{{ detailData.remark }}</span>
				</el-col>
			</el-row>
			<div slot="footer" style="text-align: center;">
				<el-button type="primary" @click="detailDialog = false">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import VPagination from '@/components/Pagination/index.vue'
import { getAppointmentShootList } from '@/api/pms'
import { getSalesmanByFullName, getMembershipListForQuery } from '@/api/crm'

export default {
	name: 'reservationService',
	components: {
		VPagination
	},
	data () {
		return {
			filterFormModel: {
				code: '',
				name: '',
				salesmanId: '',
				serviceType: '',
				status: '',
				page: 1,
				dateStart: '',
				dateEnd: '',
				isAdmin: true
			},
			detailDialog: false,
			detailData: {},
			dialogVisible: false,
			tableData: [],
			queryInfo: {
				pageNum: 1, // 当前显示第几页
				pageSize: 10, // 每一页显示条数
				total: 0
			},
			rememberScroll: null,
			salemanList: [],
			storeListByCode: []
		}
	},
	watch: {
		$route: {
			handler: function (newRoute, oldRoute) {
				console.log('当前路由：', newRoute)
				console.log('之前的路由：', oldRoute)
				if (newRoute.path == '/piya/reservationRecord') {
					this.filterFormModel.systemCode = 'PIYA'
				} else {
					this.filterFormModel.systemCode = ''
				}
				if (oldRoute && (oldRoute.path == '/piya/reservationRecord' || oldRoute.path == '/videoSeason/reservationRecord')) {
					this.fetchList()
				}
			},
			// 深度观察监听
			deep: true,
			immediate: true
		}
	},
	async mounted () {
		this.fetchList()
	},
	methods: {
		selectSalemanList (val) {
			if (val.trim()) {
				getSalesmanByFullName(val).then(res => {
					if (res.data.success) {
						this.salemanList = res.data.data
					}
				})
			}
		},
		filterByName (val) {
			if (val.trim()) {
				getMembershipListForQuery({ name: val }).then(res => {
					if (res.data.success) {
						this.storeListByCode = res.data.data
					}
				})
			}
		},
		filterMethod (val) {
			if (val.trim()) {
				getMembershipListForQuery({ code: val }).then(res => {
					if (res.data.success) {
						this.storeListByCode = res.data.data
					}
				})
			}
		},
		handleSearch () {
			this.queryInfo.pageNum = 1
			this.fetchList()
		},
		handleViewDetail (row) {
			this.detailDialog = true
			this.detailData = row
		},
		async fetchList () {
			try {
				if (this.filterFormModel.reservationDate) {
					this.filterFormModel.dateStart = this.filterFormModel.reservationDate[0]
					this.filterFormModel.dateEnd = this.filterFormModel.reservationDate[1]
				} else {
					this.filterFormModel.dateStart = ''
					this.filterFormModel.dateEnd = ''
				}
				const res = await getAppointmentShootList({ pageNum: this.queryInfo.pageNum, pageSize: this.queryInfo.pageSize, vo: this.filterFormModel })
				if (res.status === 200 && res.data.success) {
					this.tableData = res.data.data.records
					this.queryInfo.total = res.data.data.total
				}
			} catch (error) {
				console.log(error)
			}
		},
		rowClassName ({ row, rowIndex }) {
			// 把每一行的索引放进row
			row.index = rowIndex
			// this.tableData[rowIndex].index = rowIndex
		}
	}
}
</script>
<style scoped lang="less">
.theme-management {
	width: 100%;
	height: 100%;
	overflow-x: hidden;
	overflow-y: scroll;
	// overflow: auto;
	-webkit-overflow-scrolling: touch;

	// &::-webkit-scrollbar {
	//   display: none;
	// }
}

.filter-form-container {
	border-top: 1px solid #ececec;
	border-bottom: 1px solid #ececec;
	padding: 20px 40px 0;
}

.add-category {
	justify-content: space-between;
}

.keywords {
	.el-input {
		width: 180px;
	}
}
</style>
